var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaximize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 294.834 294.834",
    style: {
      enableBackground: "new 0 0 294.834 294.834"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil-white",
    d: "M288.834,0H47.413c-3.313,0-6,2.687-6,6v17.398c0,3.313,2.687,6,6,6s6-2.687,6-6V12h229.421v229.421h-11.398 c-3.313,0-6,2.687-6,6s2.687,6,6,6h17.398c3.313,0,6-2.687,6-6V6C294.834,2.687,292.147,0,288.834,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil-white",
    d: "M247.421,41.413H6c-3.313,0-6,2.687-6,6v241.421c0,3.313,2.687,6,6,6h241.421c3.313,0,6-2.687,6-6V47.413 C253.421,44.1,250.734,41.413,247.421,41.413z M241.421,282.834H12V53.413h229.421V282.834z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximize);
export default __webpack_public_path__ + "static/media/maximize.2bfd0c643767adbe62f38d93b9334046.svg";
export { ForwardRef as ReactComponent };